angular
  .module('data-ng-path-item')
  .constant('TaskBuilderDTD', {
    id: 'id',
    nk: 'string',
    repeated_by: 'id',
    event: 'id',
    item: 'id',
    status_changed_ts: {
      type: 'moment',
      rules: {
        defaultsToNow: false
      }
    },
    base_ts: {
      type: 'moment',
      rules: {
        defaultsToNow: false
      }
    },
    start_ts: {
      type: 'moment',
      rules: {
        defaultsToNow: false
      }
    },
    end_ts: {
      type: 'moment',
      rules: {
        defaultsToNow: false
      }
    },
    calendar_synced_ts: {
      type: 'moment',
      rules: {
        defaultsToNow: false
      },
      writeToKey: 'calendar_synced'
    },
    is_completable: 'boolean',
    is_dismissible: 'boolean',
    is_overdue: 'boolean',
    is_pending_complete: 'boolean',
    mandatory: 'boolean',
    overdue_days: 'number',
    overdue_message: 'string',
    show: 'boolean',
    status: 'string',
    _item: 'object',
    _title: 'string',
    _text: 'string',
    _link_to_appt_scheduling: 'boolean',
    substitute_text_by_field_by_item: 'object',
    category: {
      optional: true,
      type: 'enum',
      typeDef: 'EventCategoryEnum',
      defaultValue: 'TO_DO'
    },
    topic_id: 'id',
    _topic: 'object'
  })
  .factory('TaskBuilder', function TaskBuilder(Interface, TaskBuilderDTD) {
    return function TaskDTO(data) {
      Interface.implement(TaskBuilderDTD, data, this);
    };
  });



// WEBPACK FOOTER //
// ./app/vendor/data-ng-path-item/src/builders/task_builder.js